<div class="col-md-12">
    <button type="button" class="btn btn-sm btn-flat-success" rippleEffect (click)="createSubTask()">
        <span data-feather="plus" [class]="'mr-25'"></span>{{'AddSubTask' | translate}}</button>
</div>
<div id="subTaskSection">
    <ng-container *ngFor="let item of subtasks">
        <div *ngIf="item.id === 0" class="input-group input-group-merge">
            <input type="text" class="form-control form-control-sm" placeholder="{{item.title | translate}}"
                [(ngModel)]="item.title" />
            <div class="input-group-append" (click)="addSubTask(item)">
                <span class="input-group-text cursor-pointer"><i data-feather="check"></i></span>
            </div>
            <div class="input-group-append" (click)="cancelSubTask(item)">
                <span class="input-group-text cursor-pointer"><i data-feather="x"></i></span>
            </div>
        </div>
        <div class="titleDiv" *ngIf="item.id !== 0">
            <div *ngIf="item.isEditMode === true" class="input-group input-group-merge">
                <input type="text" class="form-control form-control-sm" placeholder="{{item.title | translate}}"
                    [(ngModel)]="item.title" />
                <div class="input-group-append" (click)="editSubTask(item)">
                    <span class="input-group-text cursor-pointer"><i data-feather="check"></i></span>
                </div>
                <div class="input-group-append" (click)="cancelSubTask(item)">
                    <span class="input-group-text cursor-pointer"><i data-feather="x"></i></span>
                </div>
            </div>
            <div *ngIf="item.isEditMode === false" class="custom-control custom-checkbox" [ngClass]="{
                    'custom-control-danger' : (ticketTaskResult.priority === priority.VeryHigh),
                    'custom-control-warning' : (ticketTaskResult.priority === priority.High),
                    'custom-control-primary' : (ticketTaskResult.priority === priority.Medium),
                    'custom-control-info' : (ticketTaskResult.priority === priority.Low),
                    'custom-control-secondary' : (ticketTaskResult.priority === priority.VeryLow)}">
                <input type="checkbox" class="custom-control-input" id="checkbox{{item.id}}" name="checkbox{{item.id}}"
                    [(ngModel)]="item.isDone" (ngModelChange)="changeIsDone(item)" />
                <label class="custom-control-label" for="checkbox{{item.id}}" *ngIf="item.isDone === false"
                    [ngClass]="{
                        'text-danger' : (ticketTaskResult.priority === priority.VeryHigh && item.assignedEmployeeId !== null),
                        'text-warning' : (ticketTaskResult.priority === priority.High && item.assignedEmployeeId !== null),
                        'text-primary' : (ticketTaskResult.priority === priority.Medium && item.assignedEmployeeId !== null),
                        'text-info' : (ticketTaskResult.priority === priority.Low && item.assignedEmployeeId !== null),
                        'text-secondary' : (ticketTaskResult.priority === priority.VeryLow && item.assignedEmployeeId !== null)}">{{item.title}}</label>
                <label class="custom-control-label" for="checkbox{{item.id}}"
                    *ngIf="item.isDone !== false"><del>{{item.title}}</del></label>
            </div>
            <div class="buttons" *ngIf="item.isEditMode === false && item.isDone === false">
                <button type="button" class="btn btn-icon" rippleEffect
                    (click)="openSubtaskAssignModal(subtaskAssignModal, item)">
                    <span data-feather="corner-down-right"></span></button>
                <button type="button" class="btn btn-icon" rippleEffect (click)="changeToEditMode(item)">
                    <span data-feather="edit-2"></span></button>
                <button type="button" class="btn btn-icon" rippleEffect (click)="openAlertModal(modalDanger, item.id)">
                    <span data-feather="trash"></span></button>
            </div>
        </div>
    </ng-container>
</div>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="deleteSubTask()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<ng-template #subtaskAssignModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-assign [assignedEmployeeId]="subtask.assignedEmployeeId" [token]="'dashboardToken'"
            [assignedEmployeeFullName]="subtask.assignedEmployeeFullName"
            [assignedEmployeePersonalPictureFileName]="subtask.assignedEmployeePersonalPictureFileName"
            [employeeDropdown]="employeeDropdown" (employeeAssigned)="assignedSubtask(subtask.id, $event)">
        </app-assign>
        <label>{{subtask.title}}</label>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>